/* Iter 321 — Stockage hors ligne (IndexedDB) : cache des réponses GET + file d'attente des mutations. */
const DB_NAME = "blitzz-offline";
const DB_VERSION = 1;
let _dbPromise = null;

function openDb() {
  if (_dbPromise) return _dbPromise;
  _dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") { reject(new Error("IndexedDB indisponible")); return; }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv", { keyPath: "key" });
      if (!db.objectStoreNames.contains("queue")) db.createObjectStore("queue", { keyPath: "id", autoIncrement: true });
      if (!db.objectStoreNames.contains("meta")) db.createObjectStore("meta", { keyPath: "key" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return _dbPromise;
}

function run(store, mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(store, mode);
    const os = tx.objectStore(store);
    let result;
    try { result = fn(os); } catch (e) { reject(e); return; }
    tx.oncomplete = () => resolve(result && "result" in result ? result.result : result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  }));
}

/* ── Cache des GET ─────────────────────────────────────────────── */
export const kvGet = (key) => run("kv", "readonly", (os) => os.get(key)).then((r) => r || null);
export const kvSet = (key, data, meta = {}) => run("kv", "readwrite", (os) => os.put({ key, data, ts: Date.now(), ...meta }));
export const kvDelete = (key) => run("kv", "readwrite", (os) => os.delete(key));
export const kvAll = () => run("kv", "readonly", (os) => os.getAll()).then((r) => r || []);
export async function kvPatch(key, fn) {
  const cur = await kvGet(key);
  if (!cur) return null;
  const next = fn(cur.data);
  await kvSet(key, next, { ts: cur.ts });
  return next;
}

/* ── File d'attente des mutations ──────────────────────────────── */
export const queueAdd = (op) => run("queue", "readwrite", (os) => os.add({ ...op, created_at: Date.now(), attempts: 0 }));
export const queueAll = () => run("queue", "readonly", (os) => os.getAll()).then((r) => r || []);
export const queueDelete = (id) => run("queue", "readwrite", (os) => os.delete(id));
export const queueUpdate = (op) => run("queue", "readwrite", (os) => os.put(op));
export const queueCount = () => run("queue", "readonly", (os) => os.count());

/* ── Méta (dernière synchro, sessions préparées…) ──────────────── */
export const metaGet = (key) => run("meta", "readonly", (os) => os.get(key)).then((r) => (r ? r.value : null));
export const metaSet = (key, value) => run("meta", "readwrite", (os) => os.put({ key, value }));
export const metaAll = () => run("meta", "readonly", (os) => os.getAll()).then((r) => r || []);
